import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  lease: generateApiPath({ prefix: AuthLevel.AUTH, name: 'lease' }),
}

export { paths }
